/**
 * Revert Undo Button Component
 *
 * Displays an undo button after a revert operation.
 * Allows users to restore deleted messages and return to the previous state.
 */

"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
type RevertUndoButtonProps = {
  canUndo: boolean;
  undoInFlight: boolean;
  onUndo: () => void;
};
const RevertUndoButton: React.FC<RevertUndoButtonProps> = t0 => {
  const $ = _c(8);
  const {
    canUndo,
    undoInFlight,
    onUndo
  } = t0;
  if (!canUndo) {
    return null;
  }
  const t1 = `h-4 w-4 ${undoInFlight ? "animate-spin" : "group-hover:-rotate-45 transition-transform"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" transform="scale(-1, 1) translate(-24, 0)" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <svg className={t1} fill="none" stroke="currentColor" viewBox="0 0 24 24">{t2}</svg>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = undoInFlight ? "Undoing Revert..." : "Undo Revert";
  let t5;
  if ($[3] !== onUndo || $[4] !== t3 || $[5] !== t4 || $[6] !== undoInFlight) {
    t5 = <div className="flex justify-center py-2"><button onClick={onUndo} disabled={undoInFlight} className="group flex items-center gap-2 rounded-lg border border-amber-600/50 bg-amber-600/10 px-4 py-2 text-sm font-medium text-amber-300 shadow-md transition-all hover:bg-amber-600/20 hover:border-amber-500 disabled:opacity-50 disabled:cursor-not-allowed" title="Undo the last revert operation and restore deleted messages">{t3}{t4}</button></div>;
    $[3] = onUndo;
    $[4] = t3;
    $[5] = t4;
    $[6] = undoInFlight;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export default RevertUndoButton;